<mat-card *ngIf="orders.length > 0" class="order-list-card">
  <h3 class="card-title">Sales Orders</h3>

  <div class="table-wrapper" cdkDropList (cdkDropListDropped)="onDrop($event)">
    <table mat-table [dataSource]="orders" class="mat-elevation-z8">

      <!-- Drag Handle -->
      <ng-container matColumnDef="dragHandle">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <mat-icon cdkDragHandle class="drag-icon">drag_indicator</mat-icon>
        </td>
      </ng-container>

      <!-- Serial -->
      <ng-container matColumnDef="serial">
        <th mat-header-cell *matHeaderCellDef>#</th>
        <td mat-cell *matCellDef="let row; let i = index">
          {{ i + 1 }}
        </td>
      </ng-container>

      <!-- Select Checkbox -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox [(ngModel)]="allSelected" (change)="onToggleAll()"></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox [(ngModel)]="row.selected" (change)="onSelectOrder(row)"></mat-checkbox>
        </td>
      </ng-container>

      <!-- Info Columns -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Order No.</th>
        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
      </ng-container>

      <ng-container matColumnDef="customerName">
        <th mat-header-cell *matHeaderCellDef>Customer</th>
        <td mat-cell *matCellDef="let row">{{ row.customerName }}</td>
      </ng-container>

      <ng-container matColumnDef="salesmanName">
        <th mat-header-cell *matHeaderCellDef>Salesman</th>
        <td mat-cell *matCellDef="let row">{{ row.salesmanName }}</td>
      </ng-container>

      <ng-container matColumnDef="numberOfItems">
        <th mat-header-cell *matHeaderCellDef>Items</th>
        <td mat-cell *matCellDef="let row">{{ row.numberOfItems }}</td>
      </ng-container>

      <ng-container matColumnDef="totalAmount">
        <th mat-header-cell *matHeaderCellDef>Total</th>
        <td mat-cell *matCellDef="let row">{{ row.totalAmount | currency:'INR':'symbol':'1.2-2' }}</td>
      </ng-container>

      <!-- Rows -->
      <tr mat-header-row *matHeaderRowDef="allColumns"></tr>
      <tr mat-row
          *matRowDef="let row; columns: allColumns"
          cdkDrag
          class="draggable-row"
          (dblclick)="openOrder.emit(row)">
      </tr>
    </table>
  </div>
</mat-card>
